/* Selman Gold – header: mobile menu toggle */
class SgHeader extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.nav = this.querySelector('.mobile-nav');
    if (!this.button || !this.nav) return;
    this.button.addEventListener('click', () => this.toggle());
    this.nav.addEventListener('click', (e) => { if (e.target.closest('a')) this.toggle(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen) { this.toggle(false); this.button.focus(); } });
    window.matchMedia('(min-width: 901px)').addEventListener('change', (e) => { if (e.matches) this.toggle(false); });
  }
  get isOpen() { return this.button.getAttribute('aria-expanded') === 'true'; }
  toggle(force) {
    const open = typeof force === 'boolean' ? force : !this.isOpen;
    this.button.setAttribute('aria-expanded', String(open));
    this.button.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    this.nav.hidden = !open;
  }
}
if (!customElements.get('sg-header')) customElements.define('sg-header', SgHeader);
